module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-00-e6d83a7da98fa06f8395e2a9c18edfae.svg";